<template>
    <div>
        <b-input-group> 
            <b-button variant="success" v-on:click="createReportRequest" v-if="!createBatchReportOpen" key="editfilter"><i class="fas fa-pen mr-1"></i>Create Batch Report</b-button>
        </b-input-group>
        <b-modal v-model="createBatchReportOpen"
                 size="lg" :title="dialogTitle"
                 no-enforce-focus
                 v-on:ok.prevent="saveBatchReportRequest"
                 :ok-disabled="saveBatchReportAvailable"
                 v-on:hidden="reset">
            <div class="ml-1 mr-1">
                <b-form-row class="mb-2">
                    <b-form-input placeholder="Batch report name" v-model="batchReportRequestName" size="sm" maxlength="100" :disabled="readOnly"></b-form-input>
                </b-form-row>
            </div>
            <div class="ml-1 mr-1">
                <b-form-row>
                    <b-form-group class="mb-2 col-md-5 pl-0">
                        <select2 ref="reportTypeSelect"
                                 name="reportTypeTypeSelect"
                                 key="reportTypeSelect"
                                 :options="allReportTypes"
                                 key-property="value"
                                 text-property="text"
                                 disable-search
                                 placeholder="Select report type"
                                 css-class="form-control-sm mb-2"
                                 dropdownCssClass="small"
                                 v-model="selectedReportType"
                                 v-on:select="reportTypeSelectionChanged"
                                 :disabled="readOnly">
                        </select2>
                    </b-form-group>
                    <b-form-group class="ml-2" v-if="allowPublic">
                        <b-form-checkbox name="isPublic"
                                         v-model="isPublic"
                                         class="mb-2"
                                         :disabled="readOnly"
                                         switch>
                            Public
                        </b-form-checkbox>
                    </b-form-group>
                </b-form-row>
            </div>
            <b-tabs size="sm" v-if="(currentFilterFields != null && currentFilterFields.length > 0) || fromColumnArray.length > 0 || toColumnArray.length > 0">
                <b-tab title="Filter">
                    <b-card v-if="readOnly">
                        <b-form-textarea readonly
                                         v-model="filterStatus"
                                         placeholder="current filter"
                                         rows="5"
                                         max-rows="6">
                        </b-form-textarea>

                    </b-card>
                    <b-card :class="readOnly?'d-none':''">
                        <filter-builder 
                            ref="filterBuilder" 
                            :fields="currentFilterFields" 
                            :filter="currentFilter"
                            @change="filterChanged">
                        </filter-builder>
                    </b-card>
                </b-tab>
                <b-tab title="Column Chooser" v-if="fromColumnArray.length > 0 || toColumnArray.length > 0">
                    <b-container class="mt-1 mb-1 p-0" style="overflow-y: scroll; overflow-x: hidden; max-height: 400px; border: 1px solid #DEE2E6;" id="columnSelectContainer">
                        <b-row>
                            <b-col class="border-right border-sedondary mt-2 h-100">
                                <h6 class="pl-2">Available Columns</h6>
                                <b-button size="sm" class="w-100 m-2" variant="success"
                                          @click="moveAllColumns('right')"
                                          :disabled="fromColumnArray.length == 0" v-if="!readOnly">
                                          Move all columns to the right <b-icon icon="arrow-right"></b-icon>
                                </b-button>
                                <draggable v-model="fromColumnArray" group="columnName" class="h-100">
                                        <b-button :disabled="readOnly" v-for="element in fromColumnArray" :key="element.id" size="sm" class="mb-1 ml-2 d-block"
                                                  @click="moveColumnToRightPanel(element)" variant="outline-info">{{element.displayName}}</b-button>
                                </draggable>
                            </b-col>
                            <b-col class="mt-2">
                                <h6>Selected Columns</h6>
                                <b-button size="sm" class="w-100 ml-0 mt-2 mb-2 " variant="success"
                                          @click="moveAllColumns('left')"
                                          :disabled="toColumnArray.length == 0"
                                          v-if="!readOnly">
                                          <b-icon icon="arrow-left"></b-icon> Move all columns to the left</b-button>
                                <draggable v-model="toColumnArray" group="columnName" class="h-100">
                                    <b-button :disabled="readOnly" v-for="element in toColumnArray" :key="element.id" size="sm" class="mb-1 d-block"
                                              @click="moveColumnToLeftPanel(element)" variant="outline-info">{{element.displayName}}</b-button>
                                </draggable>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-tab>
                <b-tab title="Sort By" v-if="fromColumnArray.length > 0 || toColumnArray.length > 0">
                    <b-container class="mt-1 mb-1 p-0" style="overflow-y: scroll; overflow-x: hidden; max-height: 400px; border: 1px solid #DEE2E6;" id="columnSelectContainer">
                        <b-row>
                            <b-col class="border-right border-sedondary mt-2 h-100">

                                <h6 class="pl-2">Sortable Columns</h6>
                                <draggable v-model="fromSortColumnArray" group="sortColumnName" class="h-100" :disabled="readOnly">
                                        <b-button :disabled="readOnly" v-for="element in fromSortColumnArray" :key="element.id" size="sm" class="mb-1 d-block ml-2"
                                                  @click="moveSortableColumnToRightPanel(element)" variant="outline-info">{{element.displayName}}</b-button>
                                </draggable>

                            </b-col>
                            <b-col class="mt-2">

                                <h6>Selected Sortable Columns</h6>
                                <draggable v-model="toSortColumnArray" group="sortColumnName" class="h-100" >

                                    <b-input-group v-for="element in toSortColumnArray" :key="element.id" class="mb-1">
                                        <b-input-group-prepend>
                                            <b-button :disabled="readOnly" @click="moveSortableColumnToLeftPanel(element)" size="sm" variant="outline-info">{{element.displayName}}</b-button>
                                        </b-input-group-prepend>
                                        <b-input-group-append>
                                            <b-button :disabled="readOnly" @click="changeSortDirection(element)" variant="info" size="sm">{{ element.direction }}</b-button>
                                        </b-input-group-append>
                                    </b-input-group>

                                </draggable>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-tab>
            </b-tabs>
        </b-modal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import ErrorsMixin from '../../mixins/ErrorsMixin';
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import UuidMixins from '../../mixins/UuidMixins';
    import Select2 from '../Select2';
    import draggable from "vuedraggable";
    import filterBuilder from '../FilterBuilder/FilterBuilder';

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);
    Vue.component('filter-builder', filterBuilder);

    export default {
        name: 'BatchReportFilter',
        mixins: [ErrorsMixin, DateTimeMixin, UuidMixins],
        components: { draggable },
        model: {
            event: 'change',
            prop: 'dialogOpen'
        },
        props: {
            dialogOpen: {
                type: Boolean,
                default: false
            },
            allReportOptions: {
                type: Array,
                default: null
            },
            allReportTypes: {
                type: Array,
                default: null
            },
            allWorkItemTypeOptions: {
                type: Array,
                default: null
            },
            allWorkItemStatusOptions: {
                type: Array,
                default: null
            },
            allOrderDeliveryStatusOptions: {
                type: Array,
                default: null
            },
            allTranscriberOptions: {
                type: Array,
                default: null
            },
            allCourtRegistryOptions: {
                type: Array,
                default: null
            },
            allCourtJurisdictionOptions: {
                type: Array,
                default: null
            },
            allCourtLocationOptions: {
                type: Array,
                default: null
            },
            allInterviewOrganisationOptions: {
                type: Array,
                default: null
            },
            allOrderingClientOptions: {
                type: Array,
                default: null
            },
            allServiceTypeOptions: {
                type: Array,
                default: null
            },
            allServiceDelayOptions: {
                type: Array,
                default: null
            },
            allOrderStatusOptions: {
                type: Array,
                default: null
            },
            allInvoiceReferenceOptions: {
                type: Array,
                default: null
            },
            allUserAccountTypeOptions: {
                type: Array,
                default: null
            },
            allUserStatusOptions: {
                type: Array,
                default: null
            },
            allUserRoleOptions: {
                type: Array,
                default: null
            },
            allAgvsaClearanceOptions: {
                type: Array,
                default: null
            },
            allTypistSkillLevelOptions: {
                type: Array,
                default: null
            },
            allEmploymentTypeOptions: {
                type: Array,
                default: null
            },
            courtRelatedWorkItemOptions: {
                type: Array,
                default: null
            },
            allQcOptions: {
                type: Array,
                required: true
            },
            allowPublic: {
                type: Boolean,
                default: true
            },
        },

        data: function () {
            return {

                filterDisplayText: null,
                
                selectedReportType: null,
                selectedReportColumns: [],
                selectedReportSortColumns: [],

                isPublic: true,
                readOnly: false,

                currentFilterFields: [],
                currentFilter: this.initialFilter,
                createBatchReportOpen: this.dialogOpen,
                batchReportRequestName: null,
                fromColumnArray: [],
                toColumnArray: [],
                fromSortColumnArray: [],
                toSortColumnArray: [],
                initialColumns: [],
                initialSortColumns: [],
            }
        },
        watch: {
            dialogOpen: function () {
                this.createBatchReportOpen = this.dialogOpen;
            }
        },
        computed: {
            tabsNavClass: function () {
                var tabsNavClass = "border-bottom-0";
                return tabsNavClass;
            },
            dialogTitle: function () {
                if (this.readOnly)
                    return "View Batch Report";
                else
                    return "Create Batch Report";
            },
            filterStatus: function () {
                if (this.filterDisplayText) return this.filterDisplayText;
                return "Inactive";
            },
            saveBatchReportAvailable: function () {
                return ((this.batchReportRequestName == null) || (this.batchReportRequestName.length < 1) ||
                    this.readOnly || ((this.toColumnArray.length < 1) && (this.selectedReportType != "WLGFinancialReport")
                    && (this.selectedReportType != "WLGSummaryReport")));
            },
        },
        methods: {
            moveAllColumns: function (direction) {

                if (direction == 'right') {
                    this.fromColumnArray.forEach(element => {
                        this.toColumnArray.push(element);
                    });
                    this.fromColumnArray = [];
                }
                if (direction == 'left') {
                    this.toColumnArray.forEach(element => {
                        this.fromColumnArray.push(element);
                    });
                    this.toColumnArray = [];
                }
            },

            // next for methods are used to move items from the left panels to the right panels
            // could be simplified to 2 methods but would ... code readability would suffer
            moveColumnToRightPanel: function (element) {
                this.fromColumnArray.splice(this.fromColumnArray.findIndex(obj => obj.id === element.id), 1);
                this.toColumnArray.push(element);
            },
            moveColumnToLeftPanel: function (element) {
                this.toColumnArray.splice(this.toColumnArray.findIndex(obj => obj.id === element.id), 1);
                this.fromColumnArray.push(element);
            },
            moveSortableColumnToRightPanel: function (element) {
                this.fromSortColumnArray.splice(this.fromSortColumnArray.findIndex(obj => obj.id === element.id), 1);
                this.toSortColumnArray.push(element);
            },
            moveSortableColumnToLeftPanel: function (element) {
                this.toSortColumnArray.splice(this.toSortColumnArray.findIndex(obj => obj.id === element.id), 1);
                this.fromSortColumnArray.push(element);
            },

            changeSortDirection: function (element) {
                if (element.direction == 'ASC') element.direction = 'DESC'
                else element.direction = 'ASC'
            },
            createToAndFromColumns: function () {
                this.selectedReportColumns.forEach(arrayElement => {
                    // ...use `element`...
                    if (this.initialColumns != null && this.initialColumns.length > 0) {
                        let obj = this.initialColumns.find((column) => column == arrayElement.name);

                        if (obj == null)
                            this.fromColumnArray.push(arrayElement);
                        else
                            this.toColumnArray.push(arrayElement);
                    }
                    else {
                        this.toColumnArray.push(arrayElement);
                    }
                });

                //now set up sort columns
                this.selectedReportSortColumns.forEach(sortArrayElement => {
                    // ...use `element`...
                    if (this.initialSortColumns != null) {
                        let obj = this.initialSortColumns.find((column) => column.name == sortArrayElement.name);

                        if (obj == null)
                            this.fromSortColumnArray.push(sortArrayElement);
                        else {
                            sortArrayElement.direction = (obj.direction == 'ascending') ? 'ASC' : 'DESC';
                            this.toSortColumnArray.push(sortArrayElement);
                        }
                    }
                    else {
                        this.fromSortColumnArray.push(sortArrayElement);
                    }
                });

            },
            saveBatchReportRequest: function () {
                if (this.batchReportRequestName == null || this.batchReportRequestName.trim() == '') {
                    this.$bvToast.toast('Batch report request not saved! Please provide a name.', {
                        title: 'Batch Report Request',
                        variant: 'danger',
                        appendToast: true
                    });
                    return;
                }
                else if (this.currentFilter == null || this.currentFilter.length < 1) {
                    this.$bvToast.toast('Batch report request not saved! Please set at least one filter.', {
                        title: 'Batch Report Request',
                        variant: 'danger',
                        appendToast: true
                    });
                    return;
                }

                let columns = this.toColumnArray.map(({ name }) => name)
                let sortColumns = this.toSortColumnArray.map(sca => ({ name: sca.name, direction: sca.direction == "ASC" ? 'ascending' : 'descending' }));


                var batchReportRequest = {
                    reportType: this.selectedReportType,
                    name: this.batchReportRequestName.trim(),
                    filter: this.currentFilter,
                    isPublic: this.isPublic,
                    columns: columns,
                    sorted: sortColumns
                };

                var url = this.$urlHelper.getApiUrl('report', 'batchreportrequest');
                axios
                    .post(url, JSON.stringify(batchReportRequest),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.$bvToast.toast('Batch Report Request saved successfully.', {
                            title: 'Batch Report Request:',
                            variant: 'success',
                            appendToast: true
                        });
                        this.$emit('filterCreated', this.currentFilter);
                        this.reset();
                        this.createBatchReportOpen = false;
                        this.$emit('change', this.createBatchReportOpen);
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.$bvToast.toast(currentErrors, {
                            title: 'Batch Report Request',
                            variant: 'danger',
                            appendToast: true
                        });
                        return;
                    });
            },
            viewOrCopyReportRequest: function (
                reportName,
                reportType,
                filter,
                initialColumns,
                initialSortColumns,
                isPublic,
                viewOnly) {
                this.batchReportRequestName = reportName;
                this.selectedReportType = reportType;
                this.currentFilter = filter;
                this.initialColumns = initialColumns
                this.initialSortColumns = initialSortColumns;
                this.reportTypeSelectionChanged();
                this.isPublic = isPublic;
                this.readOnly = viewOnly
                this.createBatchReportOpen = true;
                this.$emit('change', this.createBatchReportOpen);
                this.$nextTick(() => {
                    if (this.$refs.filterBuilder) this.filterDisplayText = this.$refs.filterBuilder.filterDisplayText;
                });
            },
            createReportRequest: function () {
                this.reset();
                this.createBatchReportOpen = true;
                this.$emit('change', this.createBatchReportOpen);
            },
            filterChanged: function (filter) {
                this.currentFilter = filter;
            },
            reset: function () {
                this.batchReportRequestName = null;
                this.selectedReportType = null;
                this.isPublic = false;
                this.readOnly = false;
                this.resetColumnsAndFilter();
            },
            resetColumnsAndFilter: function () {
                this.currentFilterFields = [];
                this.currentFilter = null;
                this.filterDisplayText = null;
                this.initialColumns = [];
                this.initialSortColumns = [];
                this.selectedReportColumns = [];
                this.selectedReportSortColumns = [];
                this.fromColumnArray = [];
                this.toColumnArray = [];
                this.fromSortColumnArray = [];
                this.toSortColumnArray = [];
            },
            reportTypeSelectionChanged: function () {
                //this.resetColumnsAndFilter();
                this.selectedReportColumns = [];
                this.selectedReportSortColumns = [];
                this.fromColumnArray = [];
                this.toColumnArray = [];
                this.fromSortColumnArray = [];
                this.toSortColumnArray = [];
                let reportOptions = this.allReportOptions.find((value) => value.reportType == this.selectedReportType);
                if (reportOptions != null) {
                    this.selectedReportColumns = reportOptions.columns;
                    this.selectedReportSortColumns = reportOptions.sortColumns;
                    this.currentFilterFields = reportOptions.filterFields.map(ff => ({
                        field: ff.field,
                        label: ff.label,
                        type: ff.type,
                        options: ff.type == 'boolean' ? [{ value: false, text: "Not " + ff.options }, { value: true, text: ff.options }] :
                            ff.options == null ? '' : this[ff.options],
                        placeholder: ff.placeholder,
                        format: ff.format
                    }));
                }
                this.createToAndFromColumns();

                console.log('current filter fields', JSON.stringify(this.currentFilterFields));
            }
        },
        mounted: function () {
        }
    }
</script>